import { TFunction } from "i18next";

export const resolveSootingDegreeExplanation = (
  sootingDegree: number,
  t: TFunction<"firefly-shared-ts-domain">,
  short?: boolean
) => {
  const resolvedShort = short ?? false;
  if (sootingDegree === 0)
    return resolvedShort
      ? t("Sooting Degree.explanation.short.0")
      : t("Sooting Degree.explanation.0");
  if (sootingDegree <= 25)
    return resolvedShort
      ? t("Sooting Degree.explanation.short.25")
      : t("Sooting Degree.explanation.25");
  if (sootingDegree <= 50)
    return resolvedShort
      ? t("Sooting Degree.explanation.short.50")
      : t("Sooting Degree.explanation.50");
  if (sootingDegree <= 75)
    return resolvedShort
      ? t("Sooting Degree.explanation.short.75")
      : t("Sooting Degree.explanation.75");
  if (sootingDegree <= 100)
    return resolvedShort
      ? t("Sooting Degree.explanation.short.100")
      : t("Sooting Degree.explanation.100");
  return resolvedShort
    ? t("Sooting Degree.explanation.short.>100")
    : t("Sooting Degree.explanation.>100");
};
